import { makeObservable, observable, flow, computed, action } from "mobx";

import { api } from "@/lib/services";
import { ApiRoutes } from "@/lib/routes";

import { Add } from "@/components/icons/IconMap";

export default class BrowseCustomFieldsStore {
  loading = false;
  sections = [];
  definitions = [];
  createSectionVisible = false;
  createDefinitionVisible = false;

  constructor(parentStore) {
    makeObservable(this, {
      loading: observable,
      sections: observable,
      definitions: observable,
      createSectionVisible: observable,
      createDefinitionVisible: observable,
      actions: computed,
      showCreateSection: action,
      hideCreateSection: action,
      showCreateDefinition: action,
      hideCreateDefinition: action,
      load: flow,
      loadDefinitions: flow,
    });

    this.parentStore = parentStore;
  }

  get actions() {
    return [
      {
        id: "customFields:addField",
        label: "New Field",
        onClick: () => this.showCreateDefinition(),
        icon: Add,
        location: "primary",
      },
      {
        id: "customFields:addSection",
        label: "New Section",
        onClick: () => this.showCreateSection(),
        icon: Add,
        location: "secondary",
      },
    ];
  }

  showCreateSection() {
    this.createSectionVisible = true;
  }

  hideCreateSection() {
    this.createSectionVisible = false;
  }

  showCreateDefinition() {
    this.createDefinitionVisible = true;
  }

  hideCreateDefinition() {
    this.createDefinitionVisible = false;
  }

  *load() {
    try {
      this.loading = true;
      const response = yield api.get(ApiRoutes.forFieldSections());
      if (response.status === 200) {
        this.sections = response.data?.items ?? [];
        return { success: true, data: response.data };
      }
    } catch (e) {
      return { success: false, error: e };
    } finally {
      this.loading = false;
    }
  }

  *loadDefinitions() {
    try {
      this.loading = true;
      const response = yield api.get(ApiRoutes.forFieldDefinitions(), { params: { search: "", page: 1 } });
      if (response.status === 200) {
        this.definitions = response.data?.items ?? [];
        return { success: true, data: response.data };
      }
    } catch (e) {
      return { success: false, error: e };
    } finally {
      this.loading = false;
    }
  }
}
